export default Object.freeze({
  0: 'Charge',
  1: 'Credit',
  Charge: 0,
  Credit: 1
});
